import React from "react";

const AuthModalHeader: React.FC = () => {
  return (
    <div className="reset-password-header mb-4">
      <div className="brand-logo">
        <img src="/img/logo.png" alt="Rodeo Picks" className="logo-img" />
      </div>
    </div>
  );
};

export default AuthModalHeader;
